export enum TemplatesList {
  DEFAULT = 'Default',
  MODERN = 'Modern',
}
